import { useMediaQuery } from '@/hooks/use-media-query';
import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';
import { DesktopSidebar } from './sidebar/desktop-sidebar';
import { MobileSidebar } from './sidebar/mobile-sidebar';
import { useSidebar } from '@/contexts/SidebarContext';

interface SidebarProps {
  isMobileOpen?: boolean;
  onMobileClose?: () => void;
  isMobileOrTablet?: boolean;
}

export default function NavigationSidebar({
  isMobileOpen = false,
  onMobileClose,
  isMobileOrTablet = false,
}: SidebarProps) {
  const [location, navigate] = useLocation();
  const { isCollapsed, setIsCollapsed } = useSidebar();

  // Detect tablet (768px - 1023px) to initialize collapsed state
  const isTablet = useMediaQuery('(min-width: 768px) and (max-width: 1023px)');
  const [openSubMenus, setOpenSubMenus] = useState<string[]>([]);

  // Update collapsed state when switching to/from tablet
  useEffect(() => {
    if (isTablet && !isCollapsed) {
      setIsCollapsed(true);
    }
  }, [isTablet, isCollapsed, setIsCollapsed]);

  const toggleSubMenu = (title: string) => {
    setOpenSubMenus((prev) =>
      prev.includes(title) ? prev.filter((item) => item !== title) : [...prev, title],
    );
  };

  // Function to navigate to a page
  const handleNavigate = (path: string) => {
    navigate(path);
    // Close mobile sidebar after navigation
    if (isMobileOrTablet && onMobileClose) {
      onMobileClose();
    }
  };

  const handleToggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <>
      {/* Mobile/Tablet Overlay Sidebar */}
      {isMobileOrTablet && (
        <MobileSidebar
          isOpen={isMobileOpen}
          onClose={onMobileClose || (() => { })}
          currentPath={location}
          openSubMenus={openSubMenus}
          onNavigate={handleNavigate}
          onToggleSubMenu={toggleSubMenu}
        />
      )}

      {/* Desktop Fixed Sidebar */}
      <DesktopSidebar
        isCollapsed={isCollapsed}
        onToggleCollapse={handleToggleCollapse}
        currentPath={location}
        openSubMenus={openSubMenus}
        onNavigate={handleNavigate}
        onToggleSubMenu={toggleSubMenu}
      />
    </>
  );
}
